import { addNewShiftFailure, addNewShiftSuccess, getAllShiftFailure, getAllShiftSuccess, editShiftFailure, editShiftSuccess } from "../constants/shift";
import { getAllShiftsApi,addNewShiftApi, editShiftDataApi } from "../../apis/shift";
import { showNotification } from "./notification";

function allShiftsSuccess(payload) {
  return ({type: getAllShiftSuccess, payload})
}

function allShiftsFailure() {
  return ({type: getAllShiftFailure})
}

function addShiftSuccess(payload) {
  return ({type: addNewShiftSuccess, payload})
}

function addShiftFailure() {
  return ({type: addNewShiftFailure})
}

function editShiftDataSuccess(payload, shiftId) {
  return ({type: editShiftSuccess, payload, shiftId})
}

function editShiftDataFailure() {
  return ({type: editShiftFailure})
}

export function getAllShifts(query) {
  return ((dispatch) => {
    getAllShiftsApi(query).then(
      (res) => {
        if (res) {
          dispatch(allShiftsSuccess(res))
        }
      },
      (error) => {
        dispatch(allShiftsFailure())
      }
    )
  })
}

export function addNewShift(query) {
  return ((dispatch) => {
    addNewShiftApi(query).then(
      (res) => {
        dispatch(addShiftSuccess(res));
        dispatch(showNotification({
          type: "success",
          message: "Success",
          description: "New Shift Added Successfully"
        }));
      },
      (error) => {
        dispatch(addShiftFailure());
        dispatch(showNotification({
          type: "error",
          message: "Unable to Add New Shift",
          description: error?.message
        }));
      }
    )
  })
}

export function editShift(query, shiftId) {
  return ((dispatch) => {
    editShiftDataApi(query, shiftId).then(
      (res) => {
        dispatch(editShiftDataSuccess(res[0], shiftId));
        dispatch(showNotification({
          type: "success",
          message: "Success",
          description: "Request sent for approval"
        }));
      },
      (error) => {
        dispatch(editShiftDataFailure());
        dispatch(showNotification({
          type: "error",
          message: "Unable to Change",
          description: error?.message
        }))
      }
    )
  })
} 